var ProfileType;
(function (ProfileType) {
  ProfileType["BUSINESS"] = "BUSINESS";
  ProfileType["PERSONAL"] = "PERSONAL";
})(ProfileType || (ProfileType = {}));

export { ProfileType };
//# sourceMappingURL=profileType.mjs.map
